import { scenesBootstrapper } from "@/presentation/helpers/scenesBootstrapper.js";

export function gameOverScene(k, winner) {
    scenesBootstrapper(k);

    k.add([
        k.rect(k.width(), k.height()),
        k.color(20, 20, 20),
        k.opacity(0.8)
    ]);

    const tColor = winner.team.color;

    // Victory Text
    k.add([
        k.text("VICTORY!", { size: 80, font: "lilita" }),
        k.pos(k.width() / 2, k.height() / 3),
        k.anchor("center"),
        k.color(tColor.r, tColor.g, tColor.b),
        k.outline(4, k.WHITE)
    ]);

    // Winner Name
    k.add([
        k.text(`${winner.team.id} PLAYER WINS`, { size: 32, font: "lilita" }),
        k.pos(k.width() / 2, k.height() / 3 + 80),
        k.anchor("center"),
        k.color(255, 255, 255)
    ]);

    // Big Winning Sheep
    const bigSheep = k.add([
        k.sprite("sheep", { anim: "run" }),
        k.pos(k.width() / 2, k.height() / 2 + 50),
        k.scale(4),
        k.anchor("center"),
        k.color(tColor.r, tColor.g, tColor.b)
    ]);

    // Back to Menu Button
    const btn = k.add([
        k.rect(240, 60, { radius: 8 }),
        k.pos(k.width() / 2, k.height() - 100),
        k.anchor("center"),
        k.color(255, 255, 255),
        k.area(),
        "menu_button"
    ]);

    btn.add([
        k.text("MAIN MENU", { size: 24, font: "lilita" }),
        k.anchor("center"),
        k.color(0, 0, 0)
    ]);

    // Button Interaction
    btn.onHoverUpdate(() => {
        btn.scale = k.vec2(1.1);
    });

    btn.onHoverEnd(() => {
        btn.scale = k.vec2(1);
    });
    btn.onClick(() => {
        k.go("menu");
    });
}